const Paginator = require("_fil_local_addon/camc-cms-base/amc_paginator");
const AUTOSCROLL_SPEED = 500;

class legalListPaginator extends Paginator {
    constructor(rootEl, opts = {}) {
        super(rootEl, opts);
        // Immediately select and cache the articles
        // this.perPage = 2;
        this.$items = this.$results.find(".legal_rectangle");
        this.$navigationContainer = this.$root.find(".paginator-container");
        this.updateStateFromUrl();
    }

    /**
     * Iterate through the result DOM elements and conditionally display the
     * elements based on the provided index bounds.
     *
     * @override
     * @param {[number, number]} bounds Minimum and maximum index for display
     */
    buildResults(bounds) {
        const [min, max] = bounds;
        let isFirst = true;
        this.$items.each((i, el) => {
            const visible = min <= i && i <= max;
            $(el).toggleClass("hide", !visible);
            $(el).removeClass("legal_rectangle--first");
            if (isFirst && visible) {
                $(el).addClass("legal_rectangle--first");
                isFirst = false;
            }
        });
    }

    /**
     * Retrieve the lower and upper bounds of result indices required for this
     * page
     *
     * @override
     * @param  {number} page Page number to retrieve values for
     * @return {[number, number]} Minimum and maximum result index to display
     */
    getResultsForPage(page) {
        return [page * this.perPage, (page + 1) * this.perPage - 1];
    }

    /**
     * Count the number of result elements
     *
     * @override
     * @return {number} Total results
     */
    getTotalResults() {
        return this.$items.length;
    }

    /**
     * Scroll smoothly to the top of the article list
     */
    onPageChange() {
        const pos = Math.round(this.$root.offset().top);
        $("html, body").animate({ scrollTop: pos - 200 }, AUTOSCROLL_SPEED);
    }

    /**
     * Scroll smoothly to the top of the article list
     */
    onPerPageChange() {
        const prevValue = this.$perPageInput.data("prev-value");
        if (prevValue && prevValue > this.$perPageInput.val()) {
            const pos = Math.round(this.$root.offset().top);
            $("html, body").animate({ scrollTop: pos - 200 }, AUTOSCROLL_SPEED);
        }
        this.$perPageInput.data("prev-value", this.$perPageInput.val());
        this.$perPageInput.blur();
    }

    /**
     * Article query API provides the total article count. This function
     * handles caching the value and conditionally rebuilding the navigation
     * when the total result changes (e.g. when performing a first-time load)
     *
     * @override
     * @param {number} resultCount Total number of results from the query
     */
    setResultCount(resultCount) {
        if (this.resultCount !== resultCount) {
            this.resultCount = resultCount;
            this.rebuildNavigation();
        }
    }

    /**
     * Generate the HTML for the paginator navigation. Includes the next and
     * previous page arrow buttons, and digit buttons for navigating to
     * individual pages.
     */
    buildNavigation() {
        const buttonCount = this.getNavButtonCount();
        const maxPages = this.getMaxPages();
        const total = this.getTotalResults();

        // Hide the entire pagination if there are not multiple pages
        this.$navigation.toggleClass("hide", maxPages < 2);

        // Hide the container of the per page input if there are less than 10 items
        this.$navigationContainer.toggleClass("hide", total < 10);

        // Calculate the smallest value to display as a pagination button
        let startAt;
        startAt = this.page - Math.floor(buttonCount / 2);
        startAt = Math.min(startAt, maxPages - buttonCount);
        startAt = Math.max(0, startAt);

        // Determine whether to show the arrows
        this.$root
            .find(".paginator__nav-button--prev")
            .toggleClass("invisible", this.page == 0 || maxPages <= buttonCount);

        this.$root
            .find(".paginator__nav-button--next")
            .toggleClass("invisible", this.page == maxPages - 1 || maxPages <= buttonCount);

        // Remove the existing digit buttons
        this.$navigation.find(".paginator__nav-button--digit").off("click").remove();

        // Generate new digit buttons
        const limit = Math.min(maxPages, buttonCount);
        const nextButton = this.$navigation.find(".paginator__nav-button--next");

        for (let i = 0; i < limit; i++) {
            this.buildNavButton(startAt + i).insertBefore(nextButton);
        }
    }
}

module.exports = legalListPaginator;
